<template>
    <div class="loader">
        <span :style="`--i: 0; background-color: ${color}`"></span>
        <span :style="`--i: 1; background-color: ${color}`"></span>
        <span :style="`--i: 2; background-color: ${color}`"></span>
    </div>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#235789'
        }
    }
}
</script>

<style scoped>
.loader {
    width: 70px;
    height: 50px;

    display: flex;
    justify-content: space-around;
    align-items: center;
}

.loader span {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgb(0 0 0 / 20%);
    animation: scale-up 1s linear infinite;
    animation-delay: calc(var(--i) * 0.3s);
}

@keyframes scale-up {
    0%,
    100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);
    }
}
</style>